/**
 * Judge.me Accessibility Enhancements
 *
 * Judge.me renders its review widget with English accessible names
 * ("94% (16) reviews with 5 star rating", "5 star review", "Sort by") and
 * offers no setting to translate them. This script rewrites them in Finnish.
 *
 * Rewritten 14.10.2026 (audit 5.1.4): the February version targeted
 * .jdgm-star[data-score] and .jdgm-helpful__btn, which the current widget no
 * longer renders, so it changed nothing. Selectors below match the widget
 * markup as of 14.10.2026; re-check them when Judge.me changes its widget.
 */
(function () {
  'use strict';

  /** Finnish decimal comma: 4.94 -> 4,94 */
  function fi(value) {
    return String(value).replace('.', ',');
  }

  function enhanceJudgeMeA11y() {
    // Rating distribution rows: the clickable stars filter the list by rating.
    document.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
      var button = row.querySelector('.jdgm-histogram__star[role="button"]');
      if (!button) return;
      var rating = row.getAttribute('data-rating');
      var count = row.getAttribute('data-frequency') || '0';
      var percent = row.getAttribute('data-percentage') || '0';
      button.setAttribute('aria-label', 'Näytä ' + rating + ' tähden arvostelut (' + count + ' kpl, ' + percent + ' %)');
    });

    // Average rating in the widget header.
    document.querySelectorAll('.jdgm-rev-widg__summary-stars[aria-label]').forEach(function (el) {
      var match = (el.getAttribute('aria-label') || '').match(/[\d.]+/);
      if (match) el.setAttribute('aria-label', 'Arvosanojen keskiarvo ' + fi(match[0]) + '/5');
    });

    // Stars of a single review.
    document.querySelectorAll('.jdgm-rev__rating[data-score]').forEach(function (el) {
      el.setAttribute('aria-label', 'Arvosana ' + el.getAttribute('data-score') + '/5');
    });

    // Preview badge on the product page (Black Horse a11y, WCAG 1.1.1 / 4.1.2): the star button
    // was named only "Katso kaikki arvostelut", so the score itself never reached screen readers.
    // The visible review count stays in the name (WCAG 2.5.3).
    document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
      var stars = badge.querySelector('.jdgm-prev-badge__stars[data-score]');
      if (!stars) return;
      var score = parseFloat(stars.getAttribute('data-score'));
      var text = badge.querySelector('.jdgm-prev-badge__text');
      var count = text ? text.textContent.trim() : '';
      if (!(score > 0)) return;
      var label = 'Arvosana ' + fi(score.toFixed(1)) + '/5. ' + (count ? 'Katso kaikki ' + count : 'Katso kaikki arvostelut');
      if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
    });

    // Review sort dropdown has only an English hidden label.
    document.querySelectorAll('select.jdgm-sort-dropdown').forEach(function (select) {
      select.setAttribute('aria-label', 'Lajittele arvostelut');
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhanceJudgeMeA11y();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Judge.me loads asynchronously and re-renders the list on sort, filter and
  // "Lataa lisää". Re-run on any change that touches a Judge.me element.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target instanceof Element && (target.closest('.jdgm-widget') || target.querySelector('.jdgm-widget'))) {
        schedule();
        return;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
